export const SubObjectiveSelector = () => {
  // const { subObjectiveIndex, setSubObjectiveIndex, refreshTopic } = useTopic();

  //issue #537 disable sub-topics
  return <></>;

  // if (!parentTopic["title"].includes("Objective")) {
  //   return <></>;
  // }

  // return (
  //   <div className="flex">
  //     {parentTopic.sub_topics?.length > 0 && (
  //       <Select
  //         className="w-[50%] mr-4"
  //         id="doc-type"
  //         options={parentTopic.sub_topics.map((_, i) => {
  //           return { value: String(i + 1) };
  //         })}
  //         value={subObjectiveIndex + 1}
  //         showSearch
  //         onChange={(value) => {
  //           setSubObjectiveIndex((prev) => {
  //             const newValue = value - 1;

  //             if (newValue !== prev) {
  //               refreshTopic();
  //             }

  //             return newValue;
  //           });
  //         }}
  //       />
  //     )}
  //     <Tooltip
  //       title={
  //         disabled
  //           ? "Only team owners can create team objectives"
  //           : "Create a new objective"
  //       }
  //     >
  //       <Button
  //         disabled={disabled}
  //         onClick={async () => {
  //           await apiRequest({
  //             subRoute: "roadmap",
  //             path: "/create_sub_objective",
  //             method: "POST",
  //             body: {
  //               topicId: parentTopic["_id"]
  //             }
  //           });

  //           await refreshTopic();
  //         }}
  //       >
  //         <FaPlus />
  //       </Button>
  //     </Tooltip>
  //   </div>
  // );
};
